import { Translation } from '@/contract/translation.contract';
import i18n from '@/shared/i18n/i18n';

class TranslatedPropertyService {
  translateProperty(property: Translation): string {
    // use the current locale to select the translation, or fallback to other languages
    return property[i18n.locale as 'nl' | 'fr' | 'en'] || property.nl || property.fr || property.en || '';
  }
}

export const translatedPropertyService = new TranslatedPropertyService();
